var DEFAULT_TRANSITION_PROPS = {
  classes: {
    enter: {
      from: 'opacity-0 scale-95',
      to: 'opacity-100 scale-100',
      transition: 'transition ease-out duration-300 transform'
    },
    exit: {
      from: 'opacity-100 scale-100',
      to: 'opacity-0 scale-95',
      transition: 'transition ease-out duration-200 transform'
    }
  }
};
var DEFAULT_TRANSITION_DURATION = {
  enter: 300,
  exit: 200
};
var DEFAULT_BACKDROP_PROPS = {
  transitionDuration: DEFAULT_TRANSITION_DURATION
};

export { DEFAULT_BACKDROP_PROPS, DEFAULT_TRANSITION_DURATION, DEFAULT_TRANSITION_PROPS };
//# sourceMappingURL=consts.js.map
